import { render, staticRenderFns } from "./ListsTable.vue?vue&type=template&id=9196c800&scoped=true"
import script from "./ListsTable.vue?vue&type=script&lang=js"
export * from "./ListsTable.vue?vue&type=script&lang=js"
import style0 from "./ListsTable.vue?vue&type=style&index=0&id=9196c800&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9196c800",
  null
  
)

export default component.exports